const salesEn = {
    category: require('../../lang/en/sales/Category').default,
    customer: require('../../lang/en/sales/Customer').default,
    customerCategory: require('../../lang/en/sales/CustomerCategory').default,
    customerGroup: require('../../lang/en/sales/CustomerGroup').default,
    customerRouteAssignment: require('../../lang/en/sales/CustomerRouteAssignment').default,
    salesOrder: require('../../lang/en/sales/CustomerSalesOrder').default,
    customerType: require('../../lang/en/sales/CustomerType').default,
    deliveryPlanning: require('../../lang/en/sales/DeliveryPlanning').default,
    dispatchAdvice: require('../../lang/en/sales/DispatchAdvice').default,
    dispatchPlanning: require('../../lang/en/sales/DispatchPlanning').default,
    grade: require('../../lang/en/sales/Grade').default,
    merchandiseRack: require('../../lang/en/sales/MerchandiseRack').default,
    paymentTerms: require('../../lang/en/sales/PaymentTerms').default,
    region: require('../../lang/en/sales/Region').default,
    routes: require('../../lang/en/sales/Routes').default,
    salesTarget: require('../../lang/en/sales/SalesTarget').default,
    stockTransfer: require('../../lang/en/sales/StockTransfer').default,
    tourPlan: require('../../lang/en/sales/TourPlan').default,
    vehicle: require('../../lang/en/sales/Vehicle').default,
    salespersonLiveLocation: require('../../lang/en/sales/SalespersonLiveLocation').default,
};

export default salesEn;